const links = [
  { href: "https://multipolar.acinvesting.fr/mentions-legales", label: "Mentions légales", testid: "pf-footer-legal-link", external: true },
  { href: "https://multipolar.acinvesting.fr/cgv", label: "CGV", testid: "pf-footer-cgv-link", external: true },
  { href: "https://multipolar.acinvesting.fr/politique-de-confidentialite", label: "Politique de confidentialité", testid: "pf-footer-privacy-link", external: true },
  { href: "/gerer-mon-abonnement", label: "Gérer mon abonnement", testid: "pf-footer-subscription-link", external: false },
  { href: "mailto:contact@acinvesting.fr", label: "Contact", testid: "pf-footer-contact-link", external: false },
];

export default function PortfolioFooter() {
  return (
    <>
      <div className="max-w-4xl mx-auto px-6 md:px-12 pt-8" data-testid="pf-disclaimer">
        <p className="!text-xs text-[#758D85] font-light text-center leading-relaxed">
          OPENACCESS est un partage, à titre informatif et pédagogique, des décisions
          d'investissement personnelles de son auteur. Il ne constitue ni un conseil en
          investissement, ni une recommandation personnalisée, ni une incitation à acheter
          ou à vendre un instrument financier. L'auteur détient les positions présentées.
          Investir comporte un risque de perte en capital. Les résultats passés ne préjugent
          pas des résultats futurs.
        </p>
      </div>
      <footer data-testid="pf-footer" className="pt-24 pb-14">
        <nav
          className="max-w-7xl mx-auto px-6 md:px-12 flex flex-wrap items-center justify-center gap-x-3 gap-y-2 text-center"
          aria-label="Liens de pied de page"
        >
          {links.map((l, i) => (
            <span key={l.testid} className="flex items-center gap-3">
              <a
                href={l.href}
                data-testid={l.testid}
                {...(l.external ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                className="font-mono text-xs tracking-[0.1em] text-[#A3B8B0] hover:text-[#F5F5F0] transition-colors"
              >
                {l.label}
              </a>
              {i < links.length - 1 && <span className="text-[#758D85]" aria-hidden="true">·</span>}
            </span>
          ))}
        </nav>
      </footer>
    </>
  );
}
